import {HistoryFilterEnum} from 'presentation/modules/myAppointments/constants/historyFilterEnum';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';
import {FilterAppointmentsHistoryParams} from './types';

export const filterAppointmentsHistory = ({
	filter,
	appointmentsList,
}: FilterAppointmentsHistoryParams) => {
	if (filter === HistoryFilterEnum.HEALTH) {
		return appointmentsList.filter(
			item =>
				item.typeAttendance === TypeAttendance.ELECTIVE && item.clinic.telemedicine === 'N',
		);
	}

	if (filter === HistoryFilterEnum.TELEHEALTH) {
		return appointmentsList.filter(
			item =>
				item.typeAttendance === TypeAttendance.ELECTIVE && item.clinic.telemedicine === 'S',
		);
	}

	if (filter === HistoryFilterEnum.EMERGENCY) {
		return appointmentsList.filter(item => item.typeAttendance === TypeAttendance.EMERGENCY);
	}

	if (filter === HistoryFilterEnum.SURGERY) {
		return appointmentsList.filter(item => item.typeAttendance === TypeAttendance.SURGERY);
	}

	return appointmentsList;
};
